import { jsx } from "panel";
import { ModalEl } from "common/components/modal";
import { BannerEl } from "common/components/banner";
import { InputEl } from "common/components/input";
import { ButtonEl } from "common/components/button";
import { ButtonTheme } from "common/components/button/constants";
import { BannerType } from "common/components/banner/types";
export function template() {
  const { inputError, inputValue } = this.state;
  const description = this.attr(`description`);
  const proxyAttrs = {};
  [`closeable`, `open`, `grow-to-content`, `not-fullscreen`].forEach((attr) => proxyAttrs[attr] = this.attr(attr));
  return /* @__PURE__ */ jsx(ModalEl, {
    attrs: proxyAttrs,
    on: { change: this.helpers.modalChanged }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".mp-confirm-container"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".mp-confirm-body"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".mp-confirm-body-content"
  }, /* @__PURE__ */ jsx(null, null, this.attr(`banner-text`) ? /* @__PURE__ */ jsx(BannerEl, {
    sel: ".mp-confirm-info-banner",
    attrs: {
      theme: `info`,
      type: BannerType.Embedded,
      "body-text": this.attr(`banner-text`)
    }
  }) : null, this.attr(`title`) ? /* @__PURE__ */ jsx("div", {
    sel: ".mp-confirm-title"
  }, this.attr(`title`)) : null, description ? this.attr(`description-allow-newline`) ? /* @__PURE__ */ jsx("div", {
    sel: ".mp-confirm-description-newline"
  }, this.helpers.formatText(description, { className: `confirm-description-newline` })) : /* @__PURE__ */ jsx("div", {
    sel: ".mp-confirm-description"
  }, description) : null, this.attr(`show-input`) ? /* @__PURE__ */ jsx(InputEl, {
    sel: ".mp-confirm-input",
    attrs: {
      elref: `confirmInput`,
      "error-message": inputError,
      "validation-status": inputError ? `invalid` : ``
    },
    hook: {
      insert: this.helpers.onInputInserted
    },
    on: {
      input: this.helpers.changeInputValue,
      keyup: this.helpers.commitInputValue,
      change: (ev) => ev.stopPropagation()
    },
    props: {
      value: inputValue
    }
  }) : null, this.bannerContent || /* @__PURE__ */ jsx("slot", null)))), /* @__PURE__ */ jsx("div", {
    sel: ".mp-confirm-buttons"
  }, !this.attr(`hide-cancel-button`) ? this.attr(`theme`) !== `info` ? /* @__PURE__ */ jsx(ButtonEl, {
    attrs: { theme: ButtonTheme.Tertiary, elref: `mpConfirmCancelButton` },
    class: {
      "mp-confirm-button-cancel": true
    },
    on: { click: this.helpers.cancel }
  }, this.attr(`cancel-button-label`) || `Cancel`) : null : null, /* @__PURE__ */ jsx(ButtonEl, {
    attrs: {
      elref: `mpConfirmConfirmButton`,
      disabled: this.helpers.isConfirmButtonDisabled(),
      theme: ButtonTheme.Primary,
      type: this.attr(`theme`) === `delete` ? this.helpers.ButtonType.Destructive : this.helpers.ButtonType.Info
    },
    class: {
      "mp-confirm-button-accept": true
    },
    on: { click: this.helpers.confirm }
  }, this.attr(`confirm-button-label`) ? this.attr(`confirm-button-label`) : this.attr(`theme`) === `delete` ? `Delete` : `Okay`))));
}
